import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import Button from "../../form/Button";
import {postData, trace} from "../../../utils/request";
import {store} from "src/store";
import {showModal} from "../../../actions";
import {UnitFormatter} from "../../../utils/formatters";

class productList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid || "productList"}
                {...props}
                columns={{
                    "actions": {
                        header: ' ',
                        width: 'cell-button',
                        renderer: (value, rowData) => {
                            return <this.props.checkStockButton {...this.props} size="xs" id={rowData.id} />;
                        }
                    },
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "name": {
                        header: 'Termék neve',
                        sortable,
                        filterable
                    },
                    ...(this.props.componentConfig.fielddefs.productclass ? {
                        "productclass.name": {
                            header: 'Termék kategória',
                            sortable,
                            filterable
                        },
                    } : {}),
                    "barcode": {
                        header: 'Vonalkód',
                        sortable,
                        filterable
                    },
                }}
                orderBy={{field: "name", direction: "ASC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default productList;
